import type { AlignMent, Direction, FieldInputType } from '@lighthouse/core'

import { DATE_FORMAT_OPTIONS } from '../../constants'
import type { Size } from './types'

export const INPUT_FIELDS: FieldInputType[] = ['email', 'notes', 'phoneNumber', 'text', 'number', 'phoneNumber']

export const fieldLabelMap = new Map<FieldInputType, string>([
    ['email', '发邮件'],
    ['phoneNumber', '拨打电话'],
    ['url', '跳转链接']
])

export const sizeMap: Record<Size, number> = {
    middle: 14,
    large: 32,
    small: 12
}

export const sizeFontWeighMap: Record<Size, number> = {
    middle: 400,
    large: 600,
    small: 400
}

// export const defaultDateFormat = 'yyyy/MM/dd HH:mm'

export const minPopoverWidth = 320

export const popoverMaxHeight = 560

export const outlineWidth = 2

export const directionMap: Record<Direction, React.CSSProperties['flexDirection']> = { vertical: 'column', horizontal: 'row' }

export const alignMap: Record<AlignMent, React.CSSProperties['alignItems']> = { left: 'flex-start', center: 'center', right: 'flex-end' }

export const inputHeightMap: Record<Size, number> = {
    middle: 80,
    large: 120,
    small: 40
}

export const defaultFormat = DATE_FORMAT_OPTIONS[0].value
